/** In-button label for paid bill receipt print (matches backend receipt route). */
export function receiptPrintButtonLabel(copyCount?: number): string {
  return copyCount === 2 ? 'In phiếu thu (2 liên)' : 'In phiếu thu';
}
